import styles from '../vacancy.module.scss'
import Button from '../../../../UI/Button/Button'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import Spinner from '../../../../UI/Spinner/Spinner'
import { ReactComponent as ShareIcon } from '../../../../assets/icons/share-icon.svg'
import { postVacancyRequest } from '../../../../api/postApi'
import { applyVacancyRecord, deleteAppliedJobs, setJobsCount } from '../../../../redux/actions/vacancies.action'
import { notify } from '../../../../helpers/notify'
import { trackVacancyApply, trackVacancyCancel, trackVacancyShare } from '../../../../utils/gtm'
import { deleteVacancyRequest } from '../../../../api/deleteApi'
import { ReactComponent as TickImg } from '../../../../assets/icons/tick.svg'
import { ReactComponent as EyeIcon } from '../../../../assets/icons/eye-open.svg'

const VacancyRightColumn = ({
  vacancy,
  loading,
  setLoading,
  setIsShareBlockOpen,
  isShareBlockOpen,
  count,
  appliedJobs,
  canDelete,
  variant,
}) => {
  const { isAdmin } = useSelector(({ authentication }) => authentication.user)
  const dispatch = useDispatch()

  const isDeleteEnabled = typeof canDelete === 'boolean' ? canDelete : appliedJobs

  const isVacancyRequestExistsError = (data) => {
    const errorCode = data?.error?.code
    const errorMessage = data?.error?.message
    const hasLegacyMessage = data?.errors?.some((item) => item?.message?.includes('Vacancy request exists'))

    return (
      errorCode === 'seafarer_vacancy_request_exists' ||
      errorMessage === 'Vacancy request exists' ||
      Boolean(hasLegacyMessage)
    )
  }

  const formatTodayRequestDate = () => {
    return new Date().toLocaleDateString('en-GB')
  }

  const applyVacancy = async (company, vacancy, e) => {
    e.stopPropagation()
    setLoading(true)

    postVacancyRequest({ company, vacancy }).then((data) => {
      if (data.ok) {
        dispatch(applyVacancyRecord(vacancy, data.request_sent_date))
        trackVacancyApply(vacancy)
        setLoading(false)
      } else {
        if (isVacancyRequestExistsError(data)) {
          dispatch(applyVacancyRecord(vacancy, formatTodayRequestDate()))
        }
        notify.errorsList(data.errors)

        setLoading(false)
      }
    })
  }
  const toShareVacancy = (e) => {
    e.stopPropagation()
    setIsShareBlockOpen(!isShareBlockOpen)
    trackVacancyShare(vacancy.id)
  }

  const isLand = variant === 'land'

  const cancelVacancy = async (id, e) => {
    e.stopPropagation()
    setLoading(true)

    try {
      await deleteVacancyRequest(id)
      trackVacancyCancel(id)
      dispatch(deleteAppliedJobs(id))
      dispatch(setJobsCount(count - 1))
    } catch (error) {
      notify.errorsList(error.errors)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.rightColumn}>
      <div className={styles.controlsBlock}>
        {!vacancy.request_sent_date && (
          <Button
            className={cn(styles.controlBtn, {
              [styles.controlBtnDisabled]: isAdmin,
              [styles.controlBtnLoading]: loading,
            })}
            onClick={(e) => applyVacancy(vacancy.company_id, vacancy.id, e)}
            disabled={isAdmin || loading}
          >
            {loading ? (
              <div className={styles.loading}>
                <Spinner size={30} borderColor='rgba(189, 189, 189, 0.47)' />
              </div>
            ) : (
              'Apply'
            )}
          </Button>
        )}
        {vacancy.request_sent_date && (
          <>
            <p className={cn(styles.requestSentDate, { [styles.requestSentDate_appliedJobs]: isDeleteEnabled })}>
              <TickImg /> Request date {vacancy.request_sent_date}
            </p>

            {isDeleteEnabled && (
              <Button
                className={styles.deleteApplication}
                size='middle-full'
                onClick={(e) => cancelVacancy(vacancy.id, e)}
                disabled={isAdmin || loading}
              >
                Delete
              </Button>
            )}
          </>
        )}
        <Button
          className={cn(styles.controlBtn, {
            [styles.controlBtnDisabled]: isAdmin,
            [styles.shareBtn]: true,
            [styles.appliedVacancyShareBtn]: vacancy.request_sent_date,
          })}
          onClick={(e) => toShareVacancy(e)}
          disabled={isAdmin || loading}
          size={'small'}
          theme={'bordered'}
        >
          Share
          <ShareIcon />
        </Button>

        <div className={styles.toOpenBlock}>
          <EyeIcon />
          <p>{vacancy.views}</p>
        </div>
      </div>
    </div>
  )
}
export default VacancyRightColumn
